import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { MatMenuModule } from '@angular/material/menu';
import { connectState } from '@examdojo/angular/util';
import { MenuFocusTrapDirective } from '@examdojo/core/dialog';
import { IconComponent } from '@examdojo/core/icon';
import { TranslocoModule } from '@jsverse/transloco';
import { switchMap } from 'rxjs';
import { TagEntityQuery } from '../../data/tag-entity.query';
import { TagBadgeComponent } from '../tag-badge/tag-badge.component';
import { TagDropdownComponent } from '../tag-dropdown/tag-dropdown.component';

@Component({
  selector: 'dojo-tag-list',
  template: `
    <div class="flex flex-wrap items-center gap-3" [matMenuTriggerFor]="tagMenu" dojoMenuFocusTrap>
      @if (!state.tags.length) {
        <a class="link-component flex items-center gap-1 text-sm font-medium">
          <dojo-icon [icon]="'tags'" />
          <span>{{ 'examdojo.tags.add_tag' | transloco }}</span>
        </a>
      }

      @if (state.tags && state.tags.length > 0) {
        <div class="flex flex-wrap items-center gap-2">
          <div class="text-secondary flex cursor-pointer items-center gap-1 text-sm font-medium">
            <dojo-icon [icon]="'tags'" />
            <span>{{ 'examdojo.tags.tags_label' | transloco }}:</span>
          </div>
          <div class="flex flex-wrap items-center gap-2">
            @for (tag of state.tags; track tag.id) {
              <dojo-tag-badge [name]="tag.name" [color]="tag.color" [emoji]="tag.emoji" class="cursor-pointer" />
            }
          </div>
        </div>
      }

      <mat-menu #tagMenu="matMenu" class="tag-dropdown-menu">
        <ng-template matMenuContent>
          <dojo-tag-dropdown [entityId]="entityId()" (click)="$event.stopPropagation()" />
        </ng-template>
      </mat-menu>
    </div>
  `,
  imports: [
    TagBadgeComponent,
    TagDropdownComponent,
    IconComponent,
    TranslocoModule,
    MatMenuModule,
    MenuFocusTrapDirective,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TagListComponent {
  constructor(private readonly tagEntityQuery: TagEntityQuery) {}

  readonly entityId = input.required<string | number>();

  readonly state = connectState({
    tags: toObservable(this.entityId).pipe(switchMap((id) => this.tagEntityQuery.selectTagsForEntity(id))),
  });
}
